// ProjectFieldGroup — Patch 010.A.4 R6 split.
// Address / city / state / zip fields for NewProjectModal.
//
// Patch 015.40-W1 — dropped the Phase select. New projects always start
// at 'planning' (backend default at routes/projects.ts:259). Heritage
// advances the lifecycle via Today's Setup Checklist + Advance banner
// (CH-2). Back-importing mid-build projects is a separate Import-flow
// surface (not the new-project modal) — file as follow-up if needed.

import type { RefObject } from 'react'

import type { Draft } from './helpers'
import { US_STATES } from './helpers'

interface Props {
  draft: Draft
  update: <K extends keyof Draft>(k: K, v: Draft[K]) => void
  initialFocusRef: RefObject<HTMLInputElement>
}

export function ProjectFieldGroup({
  draft,
  update,
  initialFocusRef,
}: Props): JSX.Element {
  return (
    <>
      <label className="hcc-field">
        <span>Address</span>
        <input
          ref={initialFocusRef}
          value={draft.address}
          onChange={(e) => update('address', e.target.value)}
          placeholder="5855 Oakridge Trail S"
          data-testid="new-project-address"
        />
      </label>
      <div className="hcc-field-row">
        <label className="hcc-field">
          <span>City</span>
          <input
            value={draft.city}
            onChange={(e) => update('city', e.target.value)}
            data-testid="new-project-city"
          />
        </label>
        <label className="hcc-field">
          <span>State</span>
          <select
            value={draft.state}
            onChange={(e) => update('state', e.target.value)}
            data-testid="new-project-state"
          >
            {US_STATES.map((s) => (
              <option key={s.code} value={s.code}>
                {s.code} — {s.name}
              </option>
            ))}
          </select>
        </label>
        <label className="hcc-field">
          <span>ZIP</span>
          <input
            value={draft.zip}
            onChange={(e) => update('zip', e.target.value)}
            placeholder="55001"
            inputMode="numeric"
            data-testid="new-project-zip"
          />
        </label>
      </div>
    </>
  )
}
